import { Expose } from 'class-transformer';
import { IsNumber, IsObject, IsOptional, IsString } from 'class-validator';
import CreatedInfo, { Created } from './created-info';
import UpdatedInfo, { Updated } from './updated-info';

export class LaundryGarment implements Updated, Created {
  @IsString()
  readonly id: string;

  @IsString()
  readonly label: string;

  @IsNumber()
  readonly price: number;

  @IsString()
  @Expose({ name: 'category_id' })
  readonly categoryId: string;

  @IsOptional()
  @IsObject()
  readonly created?: CreatedInfo;

  @IsOptional()
  @IsObject()
  readonly updated?: UpdatedInfo;

  constructor(init: LaundryGarment | Partial<LaundryGarment>) {
    this.id = init?.id!;
    this.label = init?.label!;
    this.price = init?.price!;
    this.categoryId = init?.categoryId!;

    this.created = init?.created;
    this.updated = init?.updated;
  }
}

export default LaundryGarment;
